import styled from 'styled-components';

export const Svg = styled.svg<{ color: string; size: string | number }>`
  fill: ${(props) => props.color};
  height: ${(props) => props.size};
`;
